import circularSawBladeImg from './Circular Saw Blade/image-1722069240843-Circular Saw Blade.jpeg';
import circularSawBladeImg1 from './Circular Saw Blade/image-1723203492399-circular-sawblade1.jpeg';
import circularSawBladeImg2 from './Circular Saw Blade/image-1723203778853-circular-sawblade2.jpeg';
import circularSawBladeImg3 from './Circular Saw Blade/image-1723203778852-circular-sawblade-3.jpeg';

import CovertingToolsImg from './Converting tools/image-1723288722462-convertingtoolsog.jpeg'
import CovertingToolsImg1 from './Converting tools/image-1723288722463-convertingtools1.jpeg'
import CovertingToolsImg2 from './Converting tools/image-1723288722469-convertingtools2.jpeg'
import CovertingToolsImg3 from './Converting tools/image-1723288722471-convertingtools3.jpeg'
import CovertingToolsImg4 from './Converting tools/image-1723288722473-convertingtools4.jpeg'
import CovertingToolsImg5 from './Converting tools/image-1723288722474-convertingtools5.jpeg'


import VeneerPeelingKnife from './Veneer peeling knives/image-1723203778857-peelingknifeog.jpeg'
import VeneerPeelingKnife1 from './Veneer peeling knives/image-1723203778855-peelingknife1.jpeg'
import VeneerPeelingKnife2 from './Veneer peeling knives/image-1723203927062-peelingknife2.jpeg'
import VeneerPeelingKnife3 from './Veneer peeling knives/image-1723203927062-peelingknife3.jpeg'


import ChainSaw from './Chain saw/image-1723286425484-chainsawog.jpeg'
import ChainSaw1 from './Chain saw/image-1723286425481-chainsaw1.jpeg'
import ChainSaw2 from './Chain saw/image-1723286425484-chainsaw2.jpeg'
import ChainSaw3 from './Chain saw/image-1723286425481-chainsaw3.jpeg'
import ChainSaw4 from './Chain saw/image-1723286575738-chainsaw4.jpeg'
import ChainSaw5 from './Chain saw/image-1723286575738-chainsaw5.jpeg'
import ChainSaw6 from './Chain saw/image-1723286575737-chainsaw6.jpeg'

import VeneerTapes from './Veneer tapes/image-1723287959700-veneertapeog.jpeg'
import VeneerTapes1 from './Veneer tapes/image-1723287959701-venertape1.jpeg'
import VeneerTapes2 from './Veneer tapes/image-1723287959717-veneertape2.jpeg'
import VeneerTapes3 from './Veneer tapes/image-1723287959717-veneertap3.jpeg'
import VeneerTapes4 from './Veneer tapes/image-1723287959717-veneertape4.jpeg'
import VeneerTapes5 from './Veneer tapes/image-1723287959717-veneertape5.jpeg'

import abrasiveImg from './Abrasive/image-1723288489771-abrasiveog.jpeg'
import abrasiveImg1 from './Abrasive/image-1723288489771-abrasive1.jpeg'
import abrasiveImg2 from './Abrasive/image-1723288489771-abrasive2.jpeg'
import abrasiveImg3 from './Abrasive/image-1723288489772-abrasive3.jpeg'
import abrasiveImg4 from './Abrasive/image-1723288489772-abrasive4.jpeg'

import MoistureMeterImg from './Moisture meter/image-1723288013253-moisturemeterog.jpeg'
import MoistureMeterImg1 from './Moisture meter/image-1723288013254-moisturemeter1.jpeg'
import MoistureMeterImg2 from './Moisture meter/image-1723288013255-moisturemeter2.jpeg'
import MoistureMeterImg3 from './Moisture meter/image-1723288013256-moisturemeter3.jpeg'
import MoistureMeterImg4 from './Moisture meter/image-1723288013257-moisturemeter4.jpeg'













const productData = [
    {
      productId: "P001",
      productName: "Circular Saw Blade",
      description: "Carbide and PCD tipped saw blade Application: wood, plywood, laminates, HDF , MDF, aluminium, metal, plastic, ferrous and non ferrous material ",
      application:"wood, plywood, laminates, HDF , MDF, aluminium, metal, plastic, ferrous and non ferrous material",
      productImages: [
        circularSawBladeImg,
        circularSawBladeImg1,
        circularSawBladeImg2,
        circularSawBladeImg3
      ]
    },
    {
      productId: "P002",
      productName: "Converting tools",
      description: "Circular knives, slitting knives, rotary sheer knives, vent trimming blades, profile cutter, cup and washer.",
      productImages: [
        CovertingToolsImg,
        CovertingToolsImg1,
        CovertingToolsImg2,
        CovertingToolsImg3,
        CovertingToolsImg4,
        CovertingToolsImg5
      ]
    },
    {
      productId: "P003",
      productName: "Veneer peeling knives",
      description: "Imported and Indian made veneer peeling knives, slicing knives, pressure bar, clipper knives and core cutting knives.",
      productImages: [
        VeneerPeelingKnife,
        VeneerPeelingKnife1,
        VeneerPeelingKnife2,
        VeneerPeelingKnife3,   
      ]
    },
    {
      productId: "P004",
      productName: "Chain Saw",
      description: "Chainsaws are available in single-person and two-person models, along with saw chains and spare parts for maintenance and performance",
      productImages: [
        ChainSaw,
        ChainSaw1,
        ChainSaw2,
        ChainSaw3,
        ChainSaw4,
        ChainSaw5,
        ChainSaw6   
      ]
    },
    {
      productId: "P005",
      productName: "Veneer tapes",
      description: "Veneer tapes consist of face tapes for finishing, core tapes for support, eco-friendly green tapes, and decorative paper tapes in various patterns",
      productImages: [
        VeneerTapes,
        VeneerTapes1,
        VeneerTapes2,
        VeneerTapes3, 
        VeneerTapes4,
        VeneerTapes5,  
      ]
    },
    {
      productId: "P006",
      productName: "Abrasive",
      description: "Your sanding solutions in the form of wide belt, narrow belt, roll, paper disc, fibre disc and many more.  Grits available:   36 , 40 , 60 , 80 , 120 ,  150 , 180 , 220 & 320.",
      productImages: [
        abrasiveImg,
        abrasiveImg1,
        abrasiveImg2,
        abrasiveImg3, 
        abrasiveImg4,
         
      ]
    },
    {
      productId: "P007",
      productName: "Moisture meter",
      description: "Pin, pinless, and RH meter with stable calibration. ",
      application:"To check moisture of wood, panels, bamboo, sheetrock, gypsum, concrete and many more",
      productImages: [
        MoistureMeterImg,
        MoistureMeterImg1,
        MoistureMeterImg2,
        MoistureMeterImg3, 
        MoistureMeterImg4,
         
      ]
    },
];



export default productData;
